import React from 'react';
const WordHeaderPreposition = ({ preposition, className = '' }) => {
  if (!preposition) return null;

  const singleCasePrepositions = {
    aus: 'dative',
    außer: 'dative',
    ausser: 'dative',
    bei: 'dative',
    mit: 'dative',
    nach: 'dative',
    seit: 'dative',
    von: 'dative',
    zu: 'dative',
    gegenüber: 'dative',
    entgegen: 'dative',
    gemäß: 'dative',
    gemäss: 'dative',
    entsprechend: 'dative',
    samt: 'dative',
    mitsamt: 'dative',
    zuliebe: 'dative',
    zufolge: 'dative',
    nahe: 'dative',
    ab: 'dative',
    durch: 'accusative',
    für: 'accusative',
    gegen: 'accusative',
    ohne: 'accusative',
    um: 'accusative',
    bis: 'accusative',
    wider: 'accusative',
    während: 'genitive',
    wegen: 'genitive',
    trotz: 'genitive',
    statt: 'genitive',
    anstatt: 'genitive',
    außerhalb: 'genitive',
    ausserhalb: 'genitive',
    innerhalb: 'genitive',
    aufgrund: 'genitive',
    infolge: 'genitive',
    jenseits: 'genitive',
    diesseits: 'genitive',
    oberhalb: 'genitive',
    unterhalb: 'genitive',
    längs: 'genitive',
    beiderseits: 'genitive',
    seitens: 'genitive',
    unweit: 'genitive',
    kraft: 'genitive',
    mangels: 'genitive',
    anhand: 'genitive',
    zwecks: 'genitive',
    angesichts: 'genitive',
    hinsichtlich: 'genitive',
    zugunsten: 'genitive',
    ungeachtet: 'genitive',
    anlässlich: 'genitive',
  };

  const prepositionKey = preposition.trim().toLowerCase();
  const singleCase = singleCasePrepositions[prepositionKey] || null;

  const getCaseColor = (caseType) => {
    if (!caseType) return 'text-[var(--ink-700)]';

    switch (caseType) {
      case 'dative':
        return 'text-[var(--das-text)]';
      case 'accusative':
        return 'text-[var(--der-text)]';
      case 'genitive':
        return 'text-[var(--ink-700)]';
      default:
        return 'text-[var(--ink-700)]';
    }
  };

  const textColor = (() => {
    switch (singleCase) {
      case 'dative':
        return 'var(--das)';
      case 'accusative':
        return 'var(--der)';
      case 'genitive':
        return '#555';
      default:
        return '#555';
    }
  })();

  return (
    <span className={`${className}`} style={{ color: textColor }}>
      {preposition}
    </span>
  );
};

export default WordHeaderPreposition;
